// Defense-in-depth regex scrubbing for PII embedded inside strings.
// Complements `stripPii()` (which only removes top-level keys) — `redactPii()`
// handles PII that travels inside URL query params, error messages, action
// names, etc., where key-based stripping doesn't apply.

const PII_PATTERNS: Array<[RegExp, string]> = [
  // Email — local-part chars + @ + domain (intentionally lax)
  [/[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g, "[email]"],
  // CPF (BR national ID) — formatted only. Raw 11 digits would false-positive any number sequence
  [/\d{3}\.\d{3}\.\d{3}-\d{2}/g, "[cpf]"],
  // CEP (BR postal code) — 5 digits + dash + 3 digits
  [/\b\d{5}-\d{3}\b/g, "[cep]"],
  // BR phone — optional +55, optional parens around area code, 4 or 5 digits + dash + 4 digits
  [/\(?\+?55\)?\s?\(?\d{2}\)?\s?9?\s?\d{4}-?\d{4}/g, "[phone]"],
];

/**
 * Replace any PII pattern found in `value` with a placeholder token.
 * Returns the input unchanged if it isn't a string.
 */
export function redactPii(value: string | undefined | null): string {
  if (typeof value !== "string") return value as unknown as string;
  let result = value;
  for (const [pattern, replacement] of PII_PATTERNS) {
    result = result.replace(pattern, replacement);
  }
  return result;
}
